import React from "react";
import "../styles/Legal.css";
import Footer from "../components/Footer";

const Refund = () => {
  return (
    <>
      <div className="legal-container">
        <h1 className="legal-title">Refund Policy</h1>
        <p className="legal-date">Effective Date: October 2025 • Last Updated: October 2025</p>

        <div className="legal-content">
          <p>
            <strong>
              CJet Dispatch (BN 8223233, Nigeria) & CJet Dispatch LLC (Entity ID 0008028488, New Mexico, USA)
            </strong>
            <br />
            Registered Offices:
            <br />• 2nd House Beside Mopo Barrack, Ilorin, Kwara State, Nigeria
            <br />• 70 Tripp Dr, Talladega, AL 35160, United States
            <br />
            Contact:{" "}
            <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a> • Website:{" "}
            <a href="https://cjetdispatch.com" target="_blank" rel="noreferrer">
              https://cjetdispatch.com
            </a>
          </p>

          <h2>1) Scope</h2>
          <p>
            This Refund Policy applies to all payments made through the CJet Dispatch Platform for dispatch, document, or
            parcel services. By submitting a payment, you agree to these terms.
          </p>

          <h2>2) Non-Refundable Services</h2>
          <p>
            All dispatch orders are final once a shipment has been submitted to a carrier and/or a tracking number has
            been issued. No refunds will be issued for:
          </p>
          <ul>
            <li>Shipments already processed or accepted by a carrier.</li>
            <li>Generated tracking numbers.</li>
            <li>
              Delays or delivery issues caused by carriers, customs, weather, or other events outside CJet’s control.
            </li>
            <li>User errors, including wrong address, incomplete documentation, or prohibited contents.</li>
          </ul>

          <h2>3) Duplicate or Erroneous Charges</h2>
          <p>
            Report suspected duplicates within seven (7) business days along with the transaction reference and proof of
            debit. Verified duplicates will be refunded to the original payment method within 5–10 business days.
          </p>

          <h2>4) Failed Transactions</h2>
          <p>
            If a transaction fails but is still debited, email{" "}
            <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a> with proof of payment and reference.
            Once verified with the payment processor, the funds will be refunded or credited to your account.
          </p>

          <h2>5) Dispute Resolution</h2>
          <p>
            Disputes regarding charges must be submitted within seven (7) calendar days of the transaction. After this
            period, all payments are deemed final. Repeated or fraudulent disputes may result in account suspension or
            termination.
          </p>

          <h2>6) Contact</h2>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a>
            <br />
            <strong>Website:</strong>{" "}
            <a href="https://cjetdispatch.com" target="_blank" rel="noreferrer">
              https://cjetdispatch.com
            </a>
            <br />
            <strong>Postal:</strong> 2nd House Beside Mopo Barrack, Ilorin, Kwara State, Nigeria
          </p>

          <p className="legal-footer">© 2025 CJet Dispatch. All rights reserved.</p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Refund;